export default __webpack_public_path__ + "static/get-the-app-thumbnail-8e5f69257dbba8fcc07bab45d7546509.png";